var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 8.5V5",
    stroke: "#002A69",
    strokeWidth: 1.14,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00022 8.50013L10.2285 9.28647",
    stroke: "#002A69",
    strokeWidth: 1.14,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 2C11.3137 2 14 4.68629 14 8C14 8.55133 13.9234 9.08468 13.7842 9.5918C13.4586 9.35018 13.0838 9.17212 12.6758 9.07812C12.7554 8.73139 12.7998 8.3709 12.7998 8C12.7998 5.34903 10.651 3.2002 8 3.2002C5.34903 3.2002 3.2002 5.34903 3.2002 8C3.2002 10.651 5.34903 12.7998 8 12.7998C8.3709 12.7998 8.73139 12.7554 9.07812 12.6758C9.17212 13.0838 9.35018 13.4586 9.5918 13.7842C9.08468 13.9234 8.55133 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2Z",
    fill: "#002A69"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10ZM12 10.8096C11.8952 10.8097 11.8105 10.8952 11.8105 11V12.541L11.4678 12.1992C11.3936 12.1251 11.2734 12.1252 11.1992 12.1992C11.1252 12.2734 11.1251 12.3936 11.1992 12.4678L11.8662 13.1348C11.9017 13.17 11.95 13.1903 12 13.1904C12.0502 13.1903 12.0992 13.1702 12.1348 13.1348L12.8018 12.4678C12.8755 12.3937 12.8754 12.2733 12.8018 12.1992C12.7276 12.1251 12.6064 12.1252 12.5322 12.1992L12.1904 12.541V11C12.1904 10.8952 12.1048 10.8097 12 10.8096Z",
    fill: "#002A69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock2);
export default __webpack_public_path__ + "static/media/Clock2.f12137ac37c94901eacd2284c212f08b.svg";
export { ForwardRef as ReactComponent };